export default __webpack_public_path__ + "static/media/Artboard 34.79388b02.png";